<icp-splitted-screen [fullContainer]="true" [contrastSide]="contrastSide">
  <ng-container left-content>
    <icp-carousel [images]="images"></icp-carousel>
  </ng-container>
  <ng-container right-content>
    <icp-onboarding
      [actions]="actions"
      [disabled]="form.invalid"
      (onClickButton)="submitForm()"
      [at-bottom]="true"
    >
      <ng-container text-content>
        <p class="title">Esqueci minha senha</p>
        <p class="subtitle">Por favor, digite o e-mail que você usou ao criar sua conta, e nós lhe enviaremos instruções
          para redefinir sua senha.</p>
      </ng-container>
      <ng-container form-content>
        <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="form-horizontal mt24">
          <div class="input-group">
            <icp-input
              id="email"
              name="email"
              label="E-mail"
              placeholder="Digite seu e-mail"
              type="email"
              formControlName="email"
              [messageError]="formErrors.email"
            ></icp-input>
          </div>
        </form>
      </ng-container>
    </icp-onboarding>
  </ng-container>
</icp-splitted-screen>
